window.LM = window.LM || {};
window.LM.formatMoney = function(cents, format) {
  if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, format).replace(/<[^>]*>/g, '');
  const key = (format || '{{amount}}').match(/\{\{\s*(\w+)\s*\}\}/)?.[1] || 'amount';
  const decimals = key.includes('no_decimals') ? 0 : 2;
  const commaDecimal = key.includes('comma_separator');
  const separator = key.includes('space_separator') ? ' ' : key.includes('apostrophe_separator') ? "'" : commaDecimal ? '.' : ',';
  const parts = (cents / 100).toFixed(decimals).split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  const amount = parts.join(commaDecimal ? ',' : '.');
  return (format || '{{amount}}').replace(/\{\{\s*\w+\s*\}\}/, amount).replace(/<[^>]*>/g, '');
};
document.addEventListener('submit', function(event) {
  const form = event.target;
  if (!form.matches('[data-lm-filter-form]')) return;
  form.querySelectorAll('input[type="number"]').forEach(input => { if (!input.value) input.disabled = true; });
});
document.addEventListener('click', function(event) {
  const control = event.target.closest('.bundle-rail [data-prev],.bundle-rail [data-next]');
  if (!control) return;
  const rail = control.closest('.bundle-rail').querySelector('.bundle-list');
  rail.scrollBy({left: control.hasAttribute('data-prev') ? -300 : 300, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
});
const lmVideoObserver = new IntersectionObserver(entries => {
  entries.forEach(({target:video,isIntersecting}) => {
    if (!video.hasAttribute('autoplay')) return;
    if (!isIntersecting || matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
    else video.play().catch(() => {});
  });
});
function observeLMVideos(root) { root.querySelectorAll('.lm-theme video[autoplay],video[autoplay]').forEach(video=>lmVideoObserver.observe(video)); }
observeLMVideos(document);
document.addEventListener('shopify:section:load', e=>observeLMVideos(e.target));
document.addEventListener('shopify:section:unload', e=>e.target.querySelectorAll('video').forEach(video=>lmVideoObserver.unobserve(video)));
